import {
  CateringStatusType,
  DestinationSystemType,
  type AuthorReference,
  type NonAttendanceApplicationDetail,
} from '@/components/AbsenceApplication/types';
import { formatDateRange, isSameApiDate } from '@/utils/date';

interface State {
  absenceLabel: string;
  cateringPreservedLabel: string;
  cateringCanceledLabel: string;
  isRiga: boolean;
  showCateringPreserved: boolean;
  showCateringCanceledChip: boolean;
  showCateringError: boolean;
  showRetry: boolean;
  showSentTo: boolean;
  periodsMatch: boolean;
  cancellationAuthor: AuthorReference;
}

export const useAbsenceCancellationState = (
  application: NonAttendanceApplicationDetail,
): State => {
  const { cateringRequest, canceledBy, canceledPeriod, absencePeriod } =
    application;
  const isCateringCanceled = cateringRequest?.isCateringCanceled ?? false;
  const isCateringError =
    cateringRequest?.statusType === CateringStatusType.Error;
  const isRiga =
    cateringRequest?.destinationSystemType === DestinationSystemType.Riga;
  const showCateringPreserved = !!cateringRequest && !isCateringCanceled;
  const showCateringCanceledChip =
    !!cateringRequest && isCateringCanceled && !isCateringError;
  const showCateringError =
    !!cateringRequest && isCateringCanceled && isCateringError;

  return {
    absenceLabel: formatDateRange(
      (canceledPeriod ?? absencePeriod).from,
      (canceledPeriod ?? absencePeriod).to,
    ),
    cateringPreservedLabel: cateringRequest
      ? formatDateRange(
          cateringRequest.cateringPeriod.from,
          cateringRequest.cateringPeriod.to,
        )
      : '',
    cateringCanceledLabel: cateringRequest?.canceledPeriod
      ? formatDateRange(
          cateringRequest.canceledPeriod.from,
          cateringRequest.canceledPeriod.to,
        )
      : '',
    isRiga,
    showCateringPreserved,
    showCateringCanceledChip,
    showCateringError,
    showRetry: showCateringError && isRiga,
    showSentTo:
      !!cateringRequest &&
      isCateringCanceled &&
      cateringRequest.destinationSystemType !== DestinationSystemType.None,
    periodsMatch:
      !!cateringRequest?.canceledPeriod &&
      isSameApiDate(
        cateringRequest.cateringPeriod.from,
        cateringRequest.canceledPeriod.from,
      ) &&
      isSameApiDate(
        cateringRequest.cateringPeriod.to,
        cateringRequest.canceledPeriod.to,
      ),
    cancellationAuthor: canceledBy ?? application.createdBy,
  };
};
